import WaitingDocs from '../components/waiting-docs/waiting-docs';
import React from 'react';

const DocsTab = () => {
  return (
    <div>
      <div style={{}}>
        <WaitingDocs />
      </div>
    </div>
  );
};

export default DocsTab;
